import BarcodeAssessmentController from 'pages/Controller/BarcodeAssessmentController';
import Loader from 'utils/Loader';
import { whiteColor } from 'utils/constants';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { FormControl, MenuItem, Select } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
function Barcodassessment() {
  const { isData, materialDataList, barcode, barcodeerror, handleOkButtonClick, handleSave, handleClear, handleChange, handleQtyChange } =
    BarcodeAssessmentController();

  const shouldRenderTable = materialDataList && materialDataList.length > 0;

  return (
    <div className="bg" style={{ display: 'block' }}>
      {isData ? (
        <div className="overlay">
          <Loader />
          <span style={{ marginLeft: '10px' }}>Data Loading...</span>
        </div>
      ) : null}
      <div className="cutrange">
        <span className="font20">Product Assessment</span>
      </div>
      <div className="cutrange" style={{ justifyContent: 'end' }}></div>
      <div className="vertical-center">
        <div style={{ display: 'flex', flexDirection: 'row', width: '80%' }}>
          <div style={{ flex: 1 }}>
            <textarea
              type="text"
              name="barcodes"
              value={barcode}
              className={`form-control inp_text`}
              id="barcodes"
              rows={7}
              cols={50}
              // onPaste={handlePaste}
              onChange={handleChange}
              autoFocus
            />
          </div>
          <div style={{ marginTop: 'auto', marginBottom: '10px', marginLeft: '10px' }}>
            <button onClick={handleOkButtonClick}>OK</button>
          </div>
        </div>
        <div style={{ width: '80%' }}>
          <p className="error">{barcodeerror}</p>
        </div>
        {shouldRenderTable ? (
          <div className="barcode-so">
            <TableContainer component={Paper} style={{ width: '80%', margin: 'auto', border: '1px solid black' }}>
              <Table sx={{ minWidth: 650 }} size="small" aria-label="table">
                <TableHead>
                  <TableRow style={{ backgroundColor: '#272829', color: 'white', textAlign: 'center', fontWeight: 'bold' }}>
                    <TableCell style={{ color: 'white', textAlign: 'center' }}>Barcode</TableCell>
                    <TableCell style={{ color: 'white', textAlign: 'center' }}>Material Code</TableCell>
                    <TableCell style={{ color: 'white', textAlign: 'center' }}>Main Group Description</TableCell>
                    <TableCell style={{ color: 'white', textAlign: 'center' }}>Chart</TableCell>
                    <TableCell style={{ color: 'white', textAlign: 'center' }}>Shade</TableCell>
                    <TableCell style={{ color: 'white', textAlign: 'center' }}>Assessment</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {materialDataList.map((Item, Index) => (
                    <TableRow
                      key={Index}
                      hover={Index % 2 === 0}
                      sx={{ backgroundColor: whiteColor, color: 'black', border: '1px solid black', textAlign: 'center' }}
                    >
                      <TableCell style={{ textAlign: 'center' }}>{Item.barcode}</TableCell>
                      <TableCell style={{ textAlign: 'center' }}>{Item.materialCode}</TableCell>
                      <TableCell style={{ textAlign: 'center' }}>{Item.materialDesc}</TableCell>
                      <TableCell style={{ textAlign: 'center' }}>{Item.chart}</TableCell>
                      <TableCell style={{ textAlign: 'center' }}>{Item.shade}</TableCell>
                      <TableCell style={{ textAlign: 'center' }}>
                        <FormControl fullWidth size="small" error={isInvalidQty(Item.qty)}>
                          <Select
                            value={Item.qty || ''}
                            displayEmpty
                            IconComponent={KeyboardArrowDownIcon}
                            onChange={(e) => handleQtyChange(Item.materialCode, e.target.value)}
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: '350px'
                                }
                              }
                            }}
                            renderValue={(selected) => {
                              if (!selected) {
                                return 'Select';
                              }
                              return selected;
                            }}
                            sx={{
                              alignItems: 'center',
                              height: '2rem',
                              width: '6rem',
                              '& .MuiSelect-select': {
                                paddingRight: '28px'
                              },
                              '& .MuiSelect-icon': {
                                color: '#555555',
                                right: '6px'
                              },
                              '& .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#555555'
                              },
                              '&:hover .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#555555'
                              },
                              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                borderColor: '#555555'
                              }
                            }}
                          >
                          <MenuItem value="" disabled>
                            Select
                          </MenuItem>
                          {Array.from({ length: 10 }, (_, i) => (
                            <MenuItem key={i + 1} value={i + 1}>
                              {i + 1}
                            </MenuItem>
                          ))}
                          </Select>
                        </FormControl>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        ) : null}
      </div>

      <div className="footer-button">
        <button onClick={handleClear} style={{ marginRight: '15px' }}>
          {'Clear'}
        </button>
        <button style={{ marginRight: '15px' }} onClick={handleSave}>
          {'Submit'}
        </button>
      </div>
    </div>
  );
}

export default Barcodassessment;

const isInvalidQty = (qty) => !qty || isNaN(qty) || Number(qty) <= 0;
